import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { CDS_POPUP_DATA } from '@cds/ng-web-components/popup';
import { BranchAgentResponse } from './branch-agent-response';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-agent-branch-pop',
  templateUrl: './agent-branch-pop.component.html',
  styleUrls: ['./agent-branch-pop.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class AgentBranchPopComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<AgentBranchPopComponent>>(MatDialogRef);
  data = inject<{
    list: BranchAgentResponse[];
    language: string;
  }>(CDS_POPUP_DATA);

  constructor() {
    this.filterRepeatData();
  }

  private filterRepeatData() {
    const agentCodeRecord: string[] = [];

    this.data.list = this.data.list.filter(item => {
      const need = item.agentCode !== undefined && !agentCodeRecord.includes(item.agentCode);
      if (need && item.agentCode !== undefined) {
        agentCodeRecord.push(item.agentCode);
      }
      return need;
    });
  }

  ngOnInit(): void {}

  agree() {
    this.dialogRef.close({ agree: true });
  }
  disagree() {
    this.dialogRef.close({ agree: false });
  }
}
